<template>
  <div v-if="!isError" :id="svgId"></div>
  <el-empty v-else class="empty" description="加载SVG失败"></el-empty>
</template>

<script>
import * as d3 from "d3"; //在vue文件里面引入d3
import Vue from "vue/dist/vue.esm.js";
import api from "@/api";
import {
  getParamsFromDtos,
  getParamsFromDtosToWs,
  dealNumWith,
} from "@/assets/js/utils";
import WebSocketClient from "@/assets/js/websocket";
export default {
  name: "SvgD3",
  props: {
    svgContainerId: {
      type: String,
      default: "svgContent",
    },
    svgId: {
      type: String,
      default: "svgTemplate",
    },
    //path为assets下静态文件，url是远程路径
    svgUrlType: {
      type: String,
      default: "path",
    },
    svgUrl: {
      type: String,
      default: null,
    },
    clientHeightOffset: {
      type: Number,
      default: 60,
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isError: false,
      svgDtos: [],
      idMap: {},
      cmdIdMap: {}, //{cmdId:entityId}
      colorOri: {},
      timeInterval: null,
      ws: null,
      zoomWidth: 1920,
      zoomHeight: 1080,
      destoryFlag: false,
    };
  },
  computed: {},
  methods: {
    handleChange(val) {
      console.log("handleChange---", val);
    },
    windowResizeEvent(callback) {
      window.onresize = function () {
        var target = this;
        if (target.resizeFlag) {
          clearTimeout(target.resizeFlag);
        }

        target.resizeFlag = setTimeout(function () {
          callback();
          target.resizeFlag = null;
        }, 100);
      };
    },
    contentResize() {
      if (document.getElementById("svgMain")) {
        // console.log(" document.getElementById(svgContainerId).clientHeight==", document.getElementById(this.svgContainerId).clientHeight);
        // console.log("document.getElementById(svgContainerId).clientWidth==", document.getElementById(this.svgContainerId).clientWidth);
        document.getElementById("svgMain").style.width =
          document.getElementById(this.svgContainerId).clientWidth + "px";
        document.getElementById("svgMain").style.height =
          document.getElementById(this.svgContainerId).clientHeight -
          this.clientHeightOffset +
          "px";
      }
    },
    getSvg() {
      const newUrl = this.svgUrl;
      console.log("getSvg---newUrl---", newUrl);
      if (this.destoryFlag) {
        return;
      }
      if (!newUrl) {
        console.log("url为空，重新获取", this);
        setTimeout(() => {
          this.getSvg();
        }, 500);
        return;
      }
      const xhr = new XMLHttpRequest();
      try {
        if (this.svgUrlType === "path") {
          xhr.open("GET", require("@/assets/" + newUrl.substr(9)), true);
        } else {
          xhr.open("GET", newUrl, true);
        }
        xhr.send();
        xhr.addEventListener("load", () => {
          // const resXML = xhr.responseXML
          const resXML = this.stringToXml(xhr.responseXML);
          if (resXML) {
            this.isError = false;
            const svgDom = resXML.documentElement.cloneNode(true); // 克隆节点
            console.log(svgDom, "---svgDom-->>>");
            // 为 svg - dom 设置宽高边框样式
            svgDom.style.width =
              document.getElementById(this.svgContainerId).clientWidth + "px";
            svgDom.style.height =
              document.getElementById(this.svgContainerId).clientHeight -
              this.clientHeightOffset +
              "px";
            // this.contentResize()
            if (this.showBorder) {
              svgDom.style.border = "1px solid yellow";
            }
            svgDom.style.backgroundColor = "#ffffff";
            // 为svg添加鼠标滚动缩放事件
            svgDom.setAttribute("v-on:mousewheel", "this.havcZooming($event)");
            svgDom.setAttribute("id", "svgMain");
            // svg - a
            // let adomNodeAll = [...svgDom.getElementsByTagName("a")];
            // console.log(adomNodeAll, '--adomNodeAll--->>>')
            //  循环修改节点样式 添加事件
            // for (let i = 0; i < adomNodeAll.length; i++) {
            //     adomNodeAll[i].style.cursor = 'pointer' // 修改节点样式
            //     let currNodeId = adomNodeAll[i].getAttribute('id')
            //     adomNodeAll[i].setAttribute("v-on:click", "this.handleClick($event, '" + currNodeId + "')"); // 为每个节点绑定点击事件
            //     let currNode = svgDom.getElementById(currNodeId)
            // }
            //  获取缩放宽高限制 属性
            let svgtag = svgDom;
            console.log(svgtag, "---svgtag-->>>");
            this.zoomWidth =
              Number(svgtag.getAttribute("width").slice(0, -2)) - 150;
            this.zoomHeight =
              Number(svgtag.getAttribute("height").slice(0, -2)) - 50;
            //  设置 id 属性
            let gtag = [...svgDom.getElementsByTagName("g")];
            gtag[0].setAttribute("id", "svgCanvas");
            /* 将svgDom对象转换成vue的虚拟dom */
            var oSerializer = new XMLSerializer();
            var sXML = oSerializer.serializeToString(svgDom);
            var Profile = Vue.extend({
              template: `<div id="${this.svgId}"> ${sXML} </div>`,
            });
            // 创建实例，并挂载到元素上
            new Profile().$mount(`#${this.svgId}`);
            //解析遍历所有svg的标签
            this.findNode(svgDom);
          } else {
            this.isError = true;
            console.log(resXML, "getSvg---resXML");
          }
        });
      } catch (error) {
        console.log(error, "getSvg---error");
      }
    },
    stringToXml(xmlString) {
      let xmlDoc = null;
      if (typeof xmlString == "string") {
        //FF
        if (document.implementation.createDocument) {
          var parser = new DOMParser();
          xmlDoc = parser.parseFromString(xmlString, "text/xml");
        } else if (window.ActiveXObject) {
          xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
          xmlDoc.async = false;
          xmlDoc.loadXML(xmlString);
        }
      } else {
        xmlDoc = xmlString;
      }
      return xmlDoc;
    },
    zoomimg(x, y) {
      // 放大缩小
      // 缩放事件绑定给svg,缩放结果设置给svg内部的g标签
      if (!x) {
        x = 0;
      }
      if (!y) {
        y = 0;
      }
      const svg = d3.select("#svgMain");
      const g = d3.select("#svgCanvas");
      // console.log(svg, g, "in havcZooming");
      //节点的缩放
      function zoomActions() {
        // console.log(d3.event, '----->>>') // undefind
        // g.attr("transform", d3.event.transform);
        g.attr("transform", d3.zoomTransform(svg.node()));
      }
      // console.log('---d3.zoomTransform(svg.node())-----',d3.zoomTransform(svg.node()))
      let zoomHandler = d3
        .zoom()
        .on("zoom", zoomActions)
        .scaleExtent([0.5, 20])
        .translateExtent([
          [0, 0],
          [this.zoomWidth, this.zoomHeight],
        ]);

      // zoomHandler(svg)
      svg.call(zoomHandler);
      svg
        .transition()
        .duration(750)
        .call(
          zoomHandler.transform,
          d3.zoomIdentity.translate(-x, -y).scale(2)
        );
      // // 点击按钮定位
      // d3.select("#reset").on("click", function () {
      //   svg
      //     .transition()
      //     .duration(750)
      //     .call(zoomHandler.transform, d3.zoomIdentity);
      // });
      // d3.select('#pos1').on('click',function(){
      //   svg.transition().duration(750).call(zoomHandler.transform, d3.zoomIdentity.translate(-10,-1500).scale(2));
      // });
      // d3.select('#pos2').on('click',function(){
      //   svg.transition().duration(750).call(zoomHandler.transform, d3.zoomIdentity.translate(-1200,-10).scale(2));
      // });
    },
    findNode(node) {
      this.svgDtos = [];
      const findNodeItem = (item) => {
        let c = item.childNodes;
        for (let i = 0; i < c.length; i++) {
          if (c[i]?.children?.length) {
            let child = c[i].children;
            for (let j = 0; j < child.length; j++) {
              if (child[j].hasAttribute("entityId")) {
                const id = child[j].getAttribute("id") ?? "";
                const entityId = child[j].getAttribute("entityId") ?? "";
                const entityType =
                  child[j].getAttribute("entityType") ?? "DEVICE";
                const textType = child[j].getAttribute("textType") ?? "value";
                const dataType =
                  child[j].getAttribute("dataType") ?? "telemetry";
                const dataKey = child[j].getAttribute("dataKey") ?? "";
                const obj = {
                  id,
                  entityId,
                  entityType,
                  textType,
                  dataType,
                  dataKey,
                };
                //第一次保存初始颜色
                if (JSON.stringify(this.colorOri) == "{}") {
                  let color = "";
                  switch (obj.textType) {
                    //文本
                    case "value":
                      color = child[j].getAttribute("fill");
                      break;
                    default:
                      break;
                  }
                  this.colorOri[obj.id] = color;
                }
                this.svgDtos.push(obj);
                this.idMap[`${entityId}-${dataKey}`] = { id, textType };
              }
            }
            if (c[i]) {
              findNodeItem(c[i]);
            }
          }
        }
      };
      //   console.log("--findNode--this.svgDtos----",this.svgDtos)
      findNodeItem(node);
      this.$nextTick(function () {
        this.getData();
        this.timeInterval = setInterval(() => {
          // this.getData();
        }, 1000 * 60); //60s刷新
        //窗口自适应,解决svg黑边
        this.windowResizeEvent(this.contentResize);
      });
    },
    addEvent() {
      console.log("addEvent");
      //  svg 点击事件
      window["handleClick"] = function (e, currNodeId) {
        let tag = e.srcElement || e.target;
        console.log(e, "点击----->>>");
      };
      //  svg 鼠标滚动事件
      window["havcZooming"] = (e) => {
        // console.log(e, 'havcZooming----->>>')
        this.zoomimg();
      };
    },
    dealSvgResponse(data) {
      const resData = this._.cloneDeep(data) || [];
      // console.log(resData,"resData");
      resData.forEach((item) => {
        const { entityId, keyTsData } = item;
        const {
          id = "",
          // entityType = "DEVICE"
        } = entityId || {};
        Array.isArray(keyTsData) &&
          keyTsData.forEach((element) => {
            const { key = "", value = "" } = element;
            const { id: domId = "", textType } =
              this.idMap[`${id}-${key}`] || {};
            let node = document.getElementById(domId);
            switch (textType) {
              //文本
              case "value":
                if (node?.children?.[0]?.innerHTML) {
                  node.children[0].innerHTML = dealNumWith(value, 1);
                }
                break;
              default:
                break;
            }
          });
      });
    },
    dealSvgResponseFromWs(res) {
      console.log("--dealSvgResponseFromWs--res----", res);
      const { subscriptionId, data } = res;
      for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
          const element = data[key];
          const { id: domId = "", textType } =
            this.idMap[`${this.cmdIdMap[subscriptionId]}-${key}`] || {};
          const value = element[0][1];
          let node = document.getElementById(domId);
          // console.log("---dealSvgResponseFromWs--domId--value-",domId,value)
          switch (textType) {
            //文本
            case "value":
              if (node?.children?.[0]?.innerHTML) {
                node.children[0].innerHTML = dealNumWith(value, 1);
              }
              break;
            default:
              break;
          }
        }
      }
    },
    async getData() {
      //先获取历史数据，
      const paramsOnce = getParamsFromDtos(this.svgDtos, this._);
      if (paramsOnce?.length) {
        let res = await api.svgGetData(paramsOnce);
        console.log(paramsOnce, res, "-----paramsOnce,res------");
        if (res?.status == 200 && res?.data?.length) {
          this.dealSvgResponse(res.data);
        } else {
          console.log("获取svg最新数据失败");
        }
      }
      //在websocket获取最新数据
      const { params, cmdIdMap } = getParamsFromDtosToWs(this.svgDtos, this._);
      this.cmdIdMap = cmdIdMap;
      console.log(params, cmdIdMap, "-----params---cmdIdMap--");
      if (params?.tsSubCmds?.length) {
        this.initWs(params);
      }
    },
    initWs(params) {
      if (this.ws) {
        this.ws.send(params);
      } else {
        let ipPort = "192.168.2.86:9090"
        if (process.env.NODE_ENV === "production") {
          ipPort=window.location.host
        } 
        this.ws = new WebSocketClient(
        `ws://${ipPort}/api/ws/plugins/telemetry?token=${window.sessionStorage.getItem(
            "token"
          )}`,
          params
        );
        // 注册消息类型回调函数
        this.ws.registerCallback("message", (data) => {
          console.log("receivedMessage:", data);
          this.dealSvgResponseFromWs(data);
        });
      }
    },
  },
  created() {
    this.getSvg();
  },
  mounted() {
    this.addEvent();
    this.$bus.$on("getChangeMenuType", (data) => {
      this.$nextTick(function () {
        this.contentResize();
      });
    });
  },
  beforeDestroy() {
    if (this.ws) {
      this.ws.closeWebsocket();
    }
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
    window.removeEventListener("resize", this.testResize);
    this.destoryFlag = true;
    this.$bus.$off("getChangeMenuType");
  },
};
</script>

<style lang="scss" scoped></style>
